// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__160nd","title":"Images45_title__3NgQr","images":"Images45_images__3RRqb"};